import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	Row,
	Col,
	Button,
	notification,
	Select,
	DatePicker,
	Modal,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { franchises57ClientsOptions } from "../../constants/Customer";
import BatchedDataModal from "./BatchedDataModal";
import { getAggregateCogsCost, getCogCost } from "../utils/CogCost";

const { Text } = Typography;
const { RangePicker } = DatePicker;

const SalesByPlantSummary = () => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [listCSV, setListCSV] = useState([]);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [plant, setPlant] = useState("All");
	const [plantName, setPlantName] = useState("All");
	const [franchise, setFranchise] = useState("All");
	const [apiNotification, contextHolder] = notification.useNotification();
	const cogsRef = useRef(undefined);
	const jobIdsRef = useRef(undefined);
	const [modalCogsOpen, setModalCogsOpen] = useState(false);
	const [refresh, setRefresh] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const onBatchedSelected = (row) => {
		const currentCogs = row.jobs[0].aggregate.cogs.map((cog) => {
			return {
				_id: cog.cog._id,
				material: cog.cog.material,
			};
		});
		cogsRef.current = currentCogs;
		jobIdsRef.current = [...row.jobs.map((i) => i._id)];
		setModalCogsOpen(true);
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		plant !== "All" && {
			title: "",
			dataIndex: "actions",
			key: "actions",
			width: 100,
			render: (_, row) => {
				return (
					<Button
						size="large"
						type="primary"
						onClick={() => onBatchedSelected(row)}
						disabled={row.jobs[0].aggregate === undefined}
					>
						Add Batched
					</Button>
				);
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Sold Price",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "CY",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCY",
					key: "missionCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCY",
					key: "sanbenitoCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCY",
					key: "brownsvilleCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		// {
		// 	title: "Commission by plant",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionCommission",
		// 			key: "missionCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoCommission",
		// 			key: "sanbenitoCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleCommission",
		// 			key: "brownsvilleCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "Seller Pay out",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionPayout",
		// 			key: "missionPayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoPayout",
		// 			key: "sanbenitoPayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvillePayout",
		// 			key: "brownsvillePayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "Clients",
		// 	dataIndex: "client",
		// 	key: "client",
		// 	render: (value) => {
		// 		return <Text>{value}</Text>;
		// 	},
		// },
		// {
		// 	title: "COGS",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionCogs",
		// 			key: "missionCogs",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoCogs",
		// 			key: "sanbenitoCogs",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleCogs",
		// 			key: "brownsvilleCogs",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "SALES",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionSales",
		// 			key: "missionSales",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoSales",
		// 			key: "sanbenitoSales",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleSales",
		// 			key: "brownsvilleSales",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "GROSS",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionGross",
		// 			key: "missionGross",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoGross",
		// 			key: "sanbenitoGross",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleGross",
		// 			key: "brownsvilleGross",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		{
			title: "COGS TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCogsTotal",
					key: "missionCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCogsTotal",
					key: "sanbenitoCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCogsTotal",
					key: "brownsvilleCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "SALES TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionSalesTotal",
					key: "missionSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoSalesTotal",
					key: "sanbenitoSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleSalesTotal",
					key: "brownsvilleSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "GROSS TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionGrossTotal",
					key: "missionGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoGrossTotal",
					key: "sanbenitoGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleGrossTotal",
					key: "brownsvilleGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		plantName !== "All" && {
			title: "Theorical Total",
			dataIndex: "totalCogsTheorical",
			key: "totalCogsTheorical",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "Actual Total",
			dataIndex: "totalCogsActual",
			key: "totalCogsActual",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "Delta",
			dataIndex: "totalCogsDelta",
			key: "totalCogsDelta",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	].filter(Boolean);

	// const [columns2, setColumns2] = useState(
	const columns2 = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		plant !== "All" && {
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Sold Price",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "CY",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCY",
					key: "missionCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCY",
					key: "sanbenitoCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCY",
					key: "brownsvilleCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		// {
		// 	title: "Commission by plant",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionCommission",
		// 			key: "missionCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoCommission",
		// 			key: "sanbenitoCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleCommission",
		// 			key: "brownsvilleCommission",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "Seller Pay out",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionPayout",
		// 			key: "missionPayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoPayout",
		// 			key: "sanbenitoPayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvillePayout",
		// 			key: "brownsvillePayout",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		{
			title: "Clients",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "COGS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCogs",
					key: "missionCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCogs",
					key: "sanbenitoCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCogs",
					key: "brownsvilleCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "SALES",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionSales",
					key: "missionSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoSales",
					key: "sanbenitoSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleSales",
					key: "brownsvilleSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "GROSS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionGross",
					key: "missionGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoGross",
					key: "sanbenitoGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleGross",
					key: "brownsvilleGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "COGS TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCogsTotal",
					key: "missionCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCogsTotal",
					key: "sanbenitoCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCogsTotal",
					key: "brownsvilleCogsTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "SALES TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionSalesTotal",
					key: "missionSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoSalesTotal",
					key: "sanbenitoSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleSalesTotal",
					key: "brownsvilleSalesTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "GROSS TOTALS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionGrossTotal",
					key: "missionGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoGrossTotal",
					key: "sanbenitoGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleGrossTotal",
					key: "brownsvilleGrossTotal",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		// {
		// 	title: "THEORICAL BATCHED",
		// 	children: [
		// 		cogs.map((cog) => {
		// 			return {
		// 				title: cog.material,
		// 				dataIndex: cog._id,
		// 				key: cog._id,
		// 				render: (value) => {
		// 					return (
		// 						<Statistic
		// 							title=""
		// 							value={value}
		// 							precision={2}
		// 							valueStyle={{ fontSize: 14 }}
		// 							prefix={"$"}
		// 						/>
		// 					);
		// 				},
		// 			};
		// 		}),
		// 	],
		// },
		// {
		// 	title: "COGS TOTALS",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionCogsTotal",
		// 			key: "missionCogsTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoCogsTotal",
		// 			key: "sanbenitoCogsTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleCogsTotal",
		// 			key: "brownsvilleCogsTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={4}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "SALES TOTALS",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionSalesTotal",
		// 			key: "missionSalesTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoSalesTotal",
		// 			key: "sanbenitoSalesTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleSalesTotal",
		// 			key: "brownsvilleSalesTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "GROSS TOTALS",
		// 	children: [
		// 		{
		// 			title: "Mission",
		// 			dataIndex: "missionGrossTotal",
		// 			key: "missionGrossTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "San Benito",
		// 			dataIndex: "sanbenitoGrossTotal",
		// 			key: "sanbenitoGrossTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Brownsville",
		// 			dataIndex: "brownsvilleGrossTotal",
		// 			key: "brownsvilleGrossTotal",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
	].filter(Boolean);

	const summaryParent = (pageData) => {
		let totalYardsTotal = 0;
		let totalUnitPriceTotal = 0;
		let missionCYTotal = 0;
		let sanbenitoCYTotal = 0;
		let brownsvilleCYTotal = 0;
		// let missionCogsTotal = 0;
		// let sanbenitoCogsTotal = 0;
		// let brownsvilleCogsTotal = 0;
		// let missionSalesTotal = 0;
		// let sanbenitoSalesTotal = 0;
		// let brownsvilleSalesTotal = 0;
		// let missionGrossTotal = 0;
		// let sanbenitoGrossTotal = 0;
		// let brownsvilleGrossTotal = 0;
		let missionCogsTotalTotal = 0;
		let sanbenitoCogsTotalTotal = 0;
		let brownsvilleCogsTotalTotal = 0;
		let missionSalesTotalTotal = 0;
		let sanbenitoSalesTotalTotal = 0;
		let brownsvilleSalesTotalTotal = 0;
		let missionGrossTotalTotal = 0;
		let sanbenitoGrossTotalTotal = 0;
		let brownsvilleGrossTotalTotal = 0;

		pageData.forEach((item) => {
			totalYardsTotal += item.totalYards;
			totalUnitPriceTotal += item.totalUnitPrice;
			missionCYTotal += item.missionCY || 0;
			sanbenitoCYTotal += item.sanbenitoCY || 0;
			brownsvilleCYTotal += item.brownsvilleCY || 0;
			// missionCogsTotal += item.missionCogs || 0;
			// sanbenitoCogsTotal += item.sanbenitoCogs || 0;
			// brownsvilleCogsTotal += item.brownsvilleCogs || 0;
			// missionSalesTotal += item.missionSales || 0;
			// sanbenitoSalesTotal += item.sanbenitoSales || 0;
			// brownsvilleSalesTotal += item.brownsvilleSales || 0;
			// missionGrossTotal += item.missionGross || 0;
			// sanbenitoGrossTotal += item.sanbenitoGross || 0;
			// brownsvilleGrossTotal += item.brownsvilleGross || 0;
			missionCogsTotalTotal += item.missionCogsTotal || 0;
			sanbenitoCogsTotalTotal += item.sanbenitoCogsTotal || 0;
			brownsvilleCogsTotalTotal += item.brownsvilleCogsTotal || 0;
			missionSalesTotalTotal += item.missionSalesTotal || 0;
			sanbenitoSalesTotalTotal += item.sanbenitoSalesTotal || 0;
			brownsvilleSalesTotalTotal += item.brownsvilleSalesTotal || 0;
			missionGrossTotalTotal += item.missionGrossTotal || 0;
			sanbenitoGrossTotalTotal += item.sanbenitoGrossTotal || 0;
			brownsvilleGrossTotalTotal += item.brownsvilleGrossTotal || 0;
		});

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={plantName === "All" ? 2 : 3} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalYardsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalUnitPriceTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell colSpan={1} />
					{(plantName === "All" || plantName === "Mission") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "San Benito") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Brownsville") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
					)}
					{/* <Table.Summary.Cell colSpan={10} /> */}
					{/* <Table.Summary.Cell>
						<Statistic
							title=""
							value={missionCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell> */}
					{(plantName === "All" || plantName === "Mission") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionCogsTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "San Benito") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoCogsTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Brownsville") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleCogsTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Mission") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionSalesTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "San Benito") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoSalesTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Brownsville") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleSalesTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Mission") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionGrossTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "San Benito") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoGrossTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
					{(plantName === "All" || plantName === "Brownsville") && (
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleGrossTotalTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					)}
				</Table.Summary.Row>
			</>
		);
	};

	const expandedRowRender = (row) => {
		const summaryChild = (pageData) => {
			let totalYardsTotal = 0;
			let totalUnitPriceTotal = 0;
			let missionCYTotal = 0;
			let sanbenitoCYTotal = 0;
			let brownsvilleCYTotal = 0;
			let missionCogsTotal = 0;
			let sanbenitoCogsTotal = 0;
			let brownsvilleCogsTotal = 0;
			let missionSalesTotal = 0;
			let sanbenitoSalesTotal = 0;
			let brownsvilleSalesTotal = 0;
			let missionGrossTotal = 0;
			let sanbenitoGrossTotal = 0;
			let brownsvilleGrossTotal = 0;
			let missionCogsTotalTotal = 0;
			let sanbenitoCogsTotalTotal = 0;
			let brownsvilleCogsTotalTotal = 0;
			let missionSalesTotalTotal = 0;
			let sanbenitoSalesTotalTotal = 0;
			let brownsvilleSalesTotalTotal = 0;
			let missionGrossTotalTotal = 0;
			let sanbenitoGrossTotalTotal = 0;
			let brownsvilleGrossTotalTotal = 0;
			let totalCogsTheorical = 0;

			let cogsTheorical = {};

			pageData.forEach((item) => {
				totalYardsTotal += item.totalYards;
				totalUnitPriceTotal += item.totalUnitPrice;
				missionCYTotal += item.missionCY || 0;
				sanbenitoCYTotal += item.sanbenitoCY || 0;
				brownsvilleCYTotal += item.brownsvilleCY || 0;
				missionCogsTotal += item.missionCogs || 0;
				sanbenitoCogsTotal += item.sanbenitoCogs || 0;
				brownsvilleCogsTotal += item.brownsvilleCogs || 0;
				missionSalesTotal += item.missionSales || 0;
				sanbenitoSalesTotal += item.sanbenitoSales || 0;
				brownsvilleSalesTotal += item.brownsvilleSales || 0;
				missionGrossTotal += item.missionGross || 0;
				sanbenitoGrossTotal += item.sanbenitoGross || 0;
				brownsvilleGrossTotal += item.brownsvilleGross || 0;
				missionCogsTotalTotal += item.missionCogsTotal || 0;
				sanbenitoCogsTotalTotal += item.sanbenitoCogsTotal || 0;
				brownsvilleCogsTotalTotal += item.brownsvilleCogsTotal || 0;
				missionSalesTotalTotal += item.missionSalesTotal || 0;
				sanbenitoSalesTotalTotal += item.sanbenitoSalesTotal || 0;
				brownsvilleSalesTotalTotal += item.brownsvilleSalesTotal || 0;
				missionGrossTotalTotal += item.missionGrossTotal || 0;
				sanbenitoGrossTotalTotal += item.sanbenitoGrossTotal || 0;
				brownsvilleGrossTotalTotal += item.brownsvilleGrossTotal || 0;
				totalCogsTheorical += item.totalCogsTheorical || 0;

				if (plant !== "All") {
					const keysChild = [
						...(row.jobs[0].aggregate
							? row.jobs[0].aggregate.cogs.map((cog) => cog.cog._id)
							: []),
					];

					keysChild.map((keyItem) => {
						if (!cogsTheorical[`theorical-${keyItem}`]) {
							cogsTheorical[`theorical-${keyItem}`] = 0;
						}
						cogsTheorical[`theorical-${keyItem}`] +=
							item[`theorical-${keyItem}`] || 0;
					});
				}
			});

			return (
				<>
					<Table.Summary.Row>
						<Table.Summary.Cell colSpan={plantName === "All" ? 1 : 2} />
						<Table.Summary.Cell>
							<Text style={{ fontSize: 14 }} strong>
								{"Total"}
							</Text>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalYardsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalUnitPriceTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell colSpan={1} />
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						<Table.Summary.Cell colSpan={1} />
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionCogsTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoCogsTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleCogsTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionCogsTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoCogsTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleCogsTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionSalesTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoSalesTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleSalesTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionGrossTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoGrossTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleGrossTotalTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{plant !== "All" &&
							Object.entries(cogsTheorical).map(([keyCog, valueCog]) => {
								return (
									<Table.Summary.Cell>
										<Statistic
											title=""
											value={valueCog}
											style={{ fontWeight: "bold" }}
											precision={2}
											valueStyle={{ fontSize: 14 }}
											prefix={"$"}
										/>
									</Table.Summary.Cell>
								);
							})}
						{plant !== "All" && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={totalCogsTheorical}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
					</Table.Summary.Row>
				</>
			);
		};

		let objActual = [];

		row.jobs.map((item) => {
			if (
				objActual.find(
					(i) => JSON.stringify(i) === JSON.stringify(item.batchedCogsData)
				) === undefined
			) {
				objActual.push(item.batchedCogsData);
			}
		});

		let jobs = row.jobs.map((item, index) => {
			let plant = {};
			let totalCogs = 0;
			switch (item.plant.name) {
				case "Mission":
					plant.missionCY = item.loadYD3;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.missionCogs = totalCogs;
					plant.missionSales = item.unitPrice;
					plant.missionGross = plant.missionSales - plant.missionCogs;
					plant.missionCogsTotal = totalCogs * item.loadYD3;
					plant.missionSalesTotal = item.unitPrice * item.loadYD3;
					plant.missionGrossTotal =
						plant.missionSalesTotal - plant.missionCogsTotal;
					break;
				case "San Benito":
					plant.sanbenitoCY = item.loadYD3;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.sanbenitoCogs = totalCogs;
					plant.sanbenitoSales = item.unitPrice;
					plant.sanbenitoGross = plant.sanbenitoSales - plant.sanbenitoCogs;
					plant.sanbenitoCogsTotal = totalCogs * item.loadYD3;
					plant.sanbenitoSalesTotal = item.unitPrice * item.loadYD3;
					plant.sanbenitoGrossTotal =
						plant.sanbenitoSalesTotal - plant.sanbenitoCogsTotal;
					break;
				case "Brownsville":
					plant.brownsvilleCY = item.loadYD3;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.brownsvilleCogs = totalCogs;
					plant.brownsvilleSales = item.unitPrice;
					plant.brownsvilleGross =
						plant.brownsvilleSales - plant.brownsvilleCogs;
					plant.brownsvilleCogsTotal = totalCogs * item.loadYD3;
					plant.brownsvilleSalesTotal = item.unitPrice * item.loadYD3;
					plant.brownsvilleGrossTotal =
						plant.brownsvilleSalesTotal - plant.brownsvilleCogsTotal;
					break;

				default:
					break;
			}

			if (plant !== "All") {
				let totalCogsTheorical = 0;
				if (item.aggregate)
					item.aggregate.cogs.map((cog) => {
						plant[`theorical-${cog.cog._id}`] =
							getCogCost(cog) * item.loadYD3;
						totalCogsTheorical +=
							getCogCost(cog) * item.loadYD3;
					});
				plant.totalCogsTheorical = totalCogsTheorical;

				if (index === 0) {
					let totalCogsActual = 0;
					objActual.map((itemBatched) => {
						if (itemBatched) {
							itemBatched.map((cog) => {
								if (!plant[`actual-${cog.cog._id}`]) {
									plant[`actual-${cog.cog._id}`] = cog.total || 0;
								} else {
									plant[`actual-${cog.cog._id}`] += cog.total;
								}
								totalCogsActual += cog.total;
							});
						} else {
							if (item.aggregate)
								item.aggregate.cogs.map((cog) => {
									plant[`actual-${cog.cog._id}`] = 0;
								});
						}
					});
					//let totalCogsActual = 0;
					// if (item.batchedCogsData) {
					// 	item.batchedCogsData.map((cog) => {
					// 		plant[`actual-${cog.cog._id}`] = cog.total || 0;
					// 		totalCogsActual += cog.total || 0;
					// 	});
					// } else {
					// 	if (item.aggregate)
					// 		item.aggregate.cogs.map((cog) => {
					// 			plant[`actual-${cog.cog._id}`] = 0;
					// 		});
					// }
					plant.totalCogsActual = totalCogsActual;

					let totalCogsDelta = 0;
					const currentJobsCogs = row.jobs;
					const theoricalBody = {};
					currentJobsCogs.map((cc) => {
						if (cc.aggregate)
							cc.aggregate.cogs.map((cog) => {
								if (!theoricalBody[`theorical-${cog.cog._id}`]) {
									theoricalBody[`theorical-${cog.cog._id}`] = 0;
								}
								theoricalBody[`theorical-${cog.cog._id}`] +=
									getCogCost(cog) * cc.loadYD3;
							});
					});

					if (item.aggregate)
						item.aggregate.cogs.map((cog) => {
							plant[`delta-${cog.cog._id}`] =
								theoricalBody[`theorical-${cog.cog._id}`] -
								(plant[`actual-${cog.cog._id}`] || 0);
							totalCogsDelta +=
								theoricalBody[`theorical-${cog.cog._id}`] -
								(plant[`actual-${cog.cog._id}`] || 0);
						});
					plant.totalCogsDelta = totalCogsDelta || 0;
				}
			}

			return {
				...item,
				key: index,
				plant: item.plant.name,
				psi: item.psiId.psi,
				totalYards: item.loadYD3,
				totalUnitPrice: item.loadYD3 * item.unitPrice,
				totalAverage:
					item.loadYD3 === 0
						? 0
						: (item.loadYD3 * item.unitPrice) / item.loadYD3,
				date: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
				client: item.customer.name,
				jobId: item.number,
				...plant,
			};
		});

		const newColumns2 = [
			...columns2,
			plant !== "All" && {
				title: "THEORICAL BATCHED",
				children: [
					...(row.jobs[0].aggregate
						? row.jobs[0].aggregate.cogs.map((cog) => {
								return {
									title: cog.cog.material,
									dataIndex: `theorical-${cog.cog._id}`,
									key: `theorical-${cog.cog._id}`,
									render: (value) => {
										if (value === null || value === undefined || value === 0) {
											return <></>;
										}
										return (
											<Statistic
												title=""
												value={value}
												precision={2}
												valueStyle={{ fontSize: 14 }}
												prefix={"$"}
											/>
										);
									},
								};
						  })
						: []),
					{
						title: "Total",
						dataIndex: "totalCogsTheorical",
						key: "totalCogsTheorical",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14, fontWeight: "bold" }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			plant !== "All" && {
				title: "ACTUAL BATCHED",
				children: [
					...(row.jobs[0].aggregate
						? row.jobs[0].aggregate.cogs.map((cog) => {
								return {
									title: cog.cog.material,
									dataIndex: `actual-${cog.cog._id}`,
									key: `actual-${cog.cog._id}`,
									render: (value) => {
										if (
											value === null ||
											value === undefined /*|| value === 0*/
										) {
											return <></>;
										}
										return (
											<Statistic
												title=""
												value={value}
												precision={2}
												valueStyle={{ fontSize: 14 }}
												prefix={"$"}
											/>
										);
									},
								};
						  })
						: []),
					{
						title: "Total",
						dataIndex: "totalCogsActual",
						key: "totalCogsActual",
						render: (value) => {
							if (value === null || value === undefined /*|| value === 0*/) {
								return <></>;
							}
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14, fontWeight: "bold" }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			plant !== "All" && {
				title: "DELTA",
				children: [
					...(row.jobs[0].aggregate
						? row.jobs[0].aggregate.cogs.map((cog) => {
								return {
									title: cog.cog.material,
									dataIndex: `delta-${cog.cog._id}`,
									key: `delta-${cog.cog._id}`,
									render: (value) => {
										if (
											value === null ||
											value === undefined /*|| value === 0*/
										) {
											return <></>;
										}
										return (
											<Statistic
												title=""
												value={value}
												precision={2}
												valueStyle={{ fontSize: 14 }}
												prefix={"$"}
											/>
										);
									},
								};
						  })
						: []),
					{
						title: "Total",
						dataIndex: "totalCogsDelta",
						key: "totalCogsDelta",
						render: (value) => {
							if (value === null || value === undefined /*|| value === 0*/) {
								return <></>;
							}
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14, fontWeight: "bold" }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
		].filter(Boolean);

		return (
			<Table
				columns={newColumns2}
				dataSource={jobs}
				pagination={false}
				summary={summaryChild}
			/>
		);
	};

	useEffect(() => {
		getPlants();
	}, []);

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate, plant, franchise, refresh]);

	const getLogisticsList = async () => {
		setLoading(true);
		setListCSV([]);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyplant/${plant}/${franchise}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const groupedPsi = data.payload
					.filter((i) => i.psiId !== null && i.psiId !== undefined)
					.reduce((acc, item) => {
						if (!acc[`${item.psiId._id}_${item.psiId.psi}`]) {
							acc[`${item.psiId._id}_${item.psiId.psi}`] = [];
						}
						acc[`${item.psiId._id}_${item.psiId.psi}`].push(item);
						return acc;
					}, {});

				const newRows = Object.entries(groupedPsi).map(([key, values]) => {
					const fistRow = values[0];
					const [psiId, psiName] = key.split("_");

					let obj = {
						key: psiId,
						index: psiId,
						customer: "All Customers",
						plant: plant === "All" ? "All Plants" : fistRow.plant.name,
						psi: psiName,
						jobs: values,
						totalYards: values.reduce((accum, r) => accum + r.loadYD3, 0),
						totalUnitPrice: values.reduce(
							(accum, r) => accum + r.loadYD3 * r.unitPrice,
							0
						),
						franchise: fistRow.franchise || "57Concrete",
					};
					return obj;
				});

				const listRows2 = [];

				const newList = newRows.map((itemRow) => {
					let plant = {
						missionCY: 0,
						// missionCommission: 0,
						// missionPayout: 0,
						missionCogs: 0,
						missionSales: 0,
						missionGross: 0,
						missionCogsTotal: 0,
						missionSalesTotal: 0,
						missionGrossTotal: 0,
						sanbenitoCY: 0,
						// sanbenitoCommission: 0,
						// sanbenitoPayout: 0,
						sanbenitoCogs: 0,
						sanbenitoSales: 0,
						sanbenitoGross: 0,
						sanbenitoCogsTotal: 0,
						sanbenitoSalesTotal: 0,
						sanbenitoGrossTotal: 0,
						brownsvilleCY: 0,
						// brownsvilleCommission: 0,
						// brownsvillePayout: 0,
						brownsvilleCogs: 0,
						brownsvilleSales: 0,
						brownsvilleGross: 0,
						brownsvilleCogsTotal: 0,
						brownsvilleSalesTotal: 0,
						brownsvilleGrossTotal: 0,
						// cogsAverage: 0,
						// salesAverage: 0,
						// grossAverage: 0,
						// utility: 0,
						totalAverage: 0,
					};

					if (plantName !== "All") {
						let theoricalCogsTotalKeys = itemRow.jobs[0].aggregate
							? itemRow.jobs[0].aggregate.cogs.map(
									(cog) => `theorical-${cog.cog._id}-total`
							  )
							: [];

						theoricalCogsTotalKeys = [
							...theoricalCogsTotalKeys,
							"totalCogsTheorical",
						];
						theoricalCogsTotalKeys.map((tc) => {
							plant[tc] = 0;
						});
					}
					let totalCogsTheorical = 0;
					let totalCogsActual = 0;
					let totalCogsDelta = 0;

					let objActual = [];

					itemRow.jobs.map((item, index) => {
						const loadYD3 = item.loadYD3;
						// const commission =
						// 	item.psiId.plants?.find((i) => i.plant === item.plant._id)
						// 		?.commission ?? 0;
						const aggregates = item.aggregate || [];
						const cogs = getAggregateCogsCost(item.aggregate);
						const gross = item.unitPrice - cogs;
						plant.totalAverage +=
							item.loadYD3 === 0
								? 0
								: (item.loadYD3 * item.unitPrice) / item.loadYD3;

						switch (item.plant.name) {
							case "Mission":
								plant.missionCY += loadYD3;
								// plant.missionCommission += commission;
								// plant.missionPayout += loadYD3 * commission;
								plant.missionCogs += cogs;
								plant.missionSales += item.unitPrice;
								plant.missionGross += gross;
								plant.missionCogsTotal += cogs * loadYD3;
								plant.missionSalesTotal += item.unitPrice * loadYD3;
								plant.missionGrossTotal += gross * loadYD3;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;
							case "San Benito":
								plant.sanbenitoCY += loadYD3;
								// plant.sanbenitoCommission += commission;
								// plant.sanbenitoPayout += loadYD3 * commission;
								plant.sanbenitoCogs += cogs;
								plant.sanbenitoSales += item.unitPrice;
								plant.sanbenitoGross += gross;
								plant.sanbenitoCogsTotal += cogs * loadYD3;
								plant.sanbenitoSalesTotal += item.unitPrice * loadYD3;
								plant.sanbenitoGrossTotal += gross * loadYD3;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;
							case "Brownsville":
								plant.brownsvilleCY += loadYD3;
								// plant.brownsvilleCommission += commission;
								// plant.brownsvillePayout += loadYD3 * commission;
								plant.brownsvilleCogs += cogs;
								plant.brownsvilleSales += item.unitPrice;
								plant.brownsvilleGross += gross;
								plant.brownsvilleCogsTotal += cogs * loadYD3;
								plant.brownsvilleSalesTotal += item.unitPrice * loadYD3;
								plant.brownsvilleGrossTotal += gross * loadYD3;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;

							default:
								break;
						}

						if (item.aggregate)
							aggregates.cogs.map((cog) => {
								plant[`theorical-${cog.cog._id}-total`] +=
									getCogCost(cog) * loadYD3;
								totalCogsTheorical +=
									getCogCost(cog) * loadYD3;
							});

						let plant2 = {};
						let totalCogs = 0;
						switch (item.plant.name) {
							case "Mission":
								plant2.missionCY = item.loadYD3;
								// plant2.missionCommission =
								// 	item.psiId.plants?.find((i) => i.plant === item.plant._id)
								// 		?.commission ?? 0;
								// plant2.missionPayout =
								// 	plant2.missionCY * plant2.missionCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.missionCogs = totalCogs;
								plant2.missionSales = item.unitPrice;
								plant2.missionGross = plant2.missionSales - plant2.missionCogs;
								plant2.missionCogsTotal = totalCogs * item.loadYD3;
								plant2.missionSalesTotal = item.unitPrice * item.loadYD3;
								plant2.missionGrossTotal =
									plant2.missionSalesTotal - plant2.missionCogsTotal;
								// plant2.cogsAverage = plant2.missionCogs;
								// plant2.salesAverage = plant2.missionSales;
								// plant2.grossAverage = plant2.missionGross;
								// plant2.utility = plant2.missionGross * plant2.missionCY;
								break;
							case "San Benito":
								plant2.sanbenitoCY = item.loadYD3;
								// plant2.sanbenitoCommission =
								// 	item.psiId.plants?.find((i) => i.plant === item.plant._id)
								// 		?.commission ?? 0;
								// plant2.sanbenitoPayout =
								// 	plant2.sanbenitoCY * plant2.sanbenitoCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.sanbenitoCogs = totalCogs;
								plant2.sanbenitoSales = item.unitPrice;
								plant2.sanbenitoGross =
									plant2.sanbenitoSales - plant2.sanbenitoCogs;
								plant2.sanbenitoCogsTotal = totalCogs * item.loadYD3;
								plant2.sanbenitoSalesTotal = item.unitPrice * item.loadYD3;
								plant2.sanbenitoGrossTotal =
									plant2.sanbenitoSalesTotal - plant2.sanbenitoCogsTotal;
								// plant2.cogsAverage = plant2.sanbenitoCogs;
								// plant2.salesAverage = plant2.sanbenitoSales;
								// plant2.grossAverage = plant2.sanbenitoGross;
								// plant2.utility = plant2.sanbenitoGross * plant2.sanbenitoCY;
								break;
							case "Brownsville":
								plant2.brownsvilleCY = item.loadYD3;
								// plant2.brownsvilleCommission =
								// 	item.psiId.plants?.find((i) => i.plant === item.plant._id)
								// 		?.commission ?? 0;
								// plant2.brownsvillePayout =
								// 	plant2.brownsvilleCY * plant2.brownsvilleCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.brownsvilleCogs = totalCogs;
								plant2.brownsvilleSales = item.unitPrice;
								plant2.brownsvilleGross =
									plant2.brownsvilleSales - plant2.brownsvilleCogs;
								plant2.brownsvilleCogsTotal = totalCogs * item.loadYD3;
								plant2.brownsvilleSalesTotal = item.unitPrice * item.loadYD3;
								plant2.brownsvilleGrossTotal =
									plant2.brownsvilleSalesTotal - plant2.brownsvilleCogsTotal;
								// plant2.cogsAverage = plant2.brownsvilleCogs;
								// plant2.salesAverage = plant2.brownsvilleSales;
								// plant2.grossAverage = plant2.brownsvilleGross;
								// plant2.utility = plant2.brownsvilleGross * plant2.brownsvilleCY;
								break;

							default:
								break;
						}
						let totalCogsTheorical2 = 0;
						if (item.aggregate)
							aggregates.cogs.map((cog) => {
								plant2[`theorical-${cog.cog._id}`] =
									getCogCost(cog) * loadYD3;
								totalCogsTheorical2 +=
									getCogCost(cog) * loadYD3;
							});

						if (
							objActual.find(
								(i) =>
									JSON.stringify(i) === JSON.stringify(item.batchedCogsData)
							) === undefined
						) {
							objActual.push(item.batchedCogsData);
						}
						if (index === itemRow.jobs.length - 1) {
							let totalCogsActual2 = 0;
							objActual.map((itemBatched) => {
								if (itemBatched) {
									itemBatched.map((cog) => {
										if (!plant2[`actual-${cog.cog._id}`]) {
											plant2[`actual-${cog.cog._id}`] = cog.total || 0;
										} else {
											plant2[`actual-${cog.cog._id}`] += cog.total;
										}
										totalCogsActual2 += cog.total;
									});
								} else {
									if (item.aggregate)
										aggregates.cogs.map((cog) => {
											plant2[`actual-${cog.cog._id}`] = 0;
										});
								}
							});
							plant2.totalCogsActual = totalCogsActual2;
							totalCogsActual = totalCogsActual2;

							// let totalCogsActual2 = 0;
							// if (item.batchedCogsData) {
							// 	item.batchedCogsData.map((cog) => {
							// 		plant2[`actual-${cog.cog._id}`] = cog.total || 0;
							// 		totalCogsActual2 += cog.total;
							// 	});
							// } else {
							// 	if (item.aggregate)
							// 		aggregates.cogs.map((cog) => {
							// 			plant2[`actual-${cog.cog._id}`] = 0;
							// 		});
							// }
							// plant2.totalCogsActual = totalCogsActual2;
							// totalCogsActual = totalCogsActual2;

							let totalCogsDelta2 = 0;
							const currentJobsCogs = itemRow.jobs;
							const theoricalBody = {};
							currentJobsCogs.map((cc) => {
								if (cc.aggregate)
									cc.aggregate.cogs.map((cog) => {
										if (!theoricalBody[`theorical-${cog.cog._id}`]) {
											theoricalBody[`theorical-${cog.cog._id}`] = 0;
										}
										theoricalBody[`theorical-${cog.cog._id}`] +=
											getCogCost(cog) * cc.loadYD3;
									});
							});

							if (item.aggregate)
								aggregates.cogs.map((cog) => {
									plant2[`delta-${cog.cog._id}`] =
										theoricalBody[`theorical-${cog.cog._id}`] -
										(plant2[`actual-${cog.cog._id}`] || 0);
									totalCogsDelta2 +=
										theoricalBody[`theorical-${cog.cog._id}`] -
										(plant2[`actual-${cog.cog._id}`] || 0);
								});
							plant2.totalCogsDelta = totalCogsDelta2 || 0;
							totalCogsDelta = totalCogsDelta2 || 0;
						}

						//calculation based on first for one day
						// if (index === 0) {
						// 	let totalCogsActual2 = 0;
						// 	if (item.batchedCogsData) {
						// 		item.batchedCogsData.map((cog) => {
						// 			plant2[`actual-${cog.cog._id}`] = cog.total || 0;
						// 			totalCogsActual2 += cog.total;
						// 		});
						// 	} else {
						// 		if (item.aggregate)
						// 			aggregates.cogs.map((cog) => {
						// 				plant2[`actual-${cog.cog._id}`] = 0;
						// 			});
						// 	}
						// 	plant2.totalCogsActual = totalCogsActual2;
						// 	totalCogsActual = totalCogsActual2;

						// 	let totalCogsDelta2 = 0;
						// 	const currentJobsCogs = itemRow.jobs;
						// 	const theoricalBody = {};
						// 	currentJobsCogs.map((cc) => {
						// 		if (cc.aggregate)
						// 			cc.aggregate.cogs.map((cog) => {
						// 				if (!theoricalBody[`theorical-${cog.cog._id}`]) {
						// 					theoricalBody[`theorical-${cog.cog._id}`] = 0;
						// 				}
						// 				theoricalBody[`theorical-${cog.cog._id}`] +=
						// 					cog.cog.unitPriceConversion * cog.quantity * cc.loadYD3;
						// 			});
						// 	});

						// 	if (item.aggregate)
						// 		aggregates.cogs.map((cog) => {
						// 			plant2[`delta-${cog.cog._id}`] =
						// 				theoricalBody[`theorical-${cog.cog._id}`] -
						// 				(plant2[`actual-${cog.cog._id}`] || 0);
						// 			totalCogsDelta2 +=
						// 				theoricalBody[`theorical-${cog.cog._id}`] -
						// 				(plant2[`actual-${cog.cog._id}`] || 0);
						// 		});
						// 	plant2.totalCogsDelta = totalCogsDelta2 || 0;
						// 	totalCogsDelta = totalCogsDelta2 || 0;
						// }

						listRows2.push({
							...item,
							key: item.psiId._id,
							plant: item.plant.name,
							psi: item.psiId.psi,
							totalYards: item.loadYD3,
							totalUnitPrice: item.loadYD3 * item.unitPrice,
							totalAverage:
								item.loadYD3 === 0
									? 0
									: (item.loadYD3 * item.unitPrice) / item.loadYD3,
							client: item.customer.name,
							totalCogsTheorical: totalCogsTheorical2,
							date: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
							jobId: item.number.toString(),
							...plant2,
						});
					});

					objActual = [];

					const jobsMission = itemRow.jobs.filter(
						(i) => i.plant.name === "Mission"
					).length;
					const jobsSanBenito = itemRow.jobs.filter(
						(i) => i.plant.name === "San Benito"
					).length;
					const jobsBrownsville = itemRow.jobs.filter(
						(i) => i.plant.name === "Brownsville"
					).length;

					return {
						...itemRow,
						...plant,
						totalAverage: plant.totalAverage / itemRow.jobs.length,
						missionCogs: plant.missionCogs / jobsMission || 0,
						missionSales: plant.missionSales / jobsMission || 0,
						missionGross: plant.missionGross / jobsMission || 0,
						sanbenitoCogs: plant.sanbenitoCogs / jobsSanBenito || 0,
						sanbenitoSales: plant.sanbenitoSales / jobsSanBenito || 0,
						sanbenitoGross: plant.sanbenitoGross / jobsSanBenito || 0,
						brownsvilleCogs: plant.brownsvilleCogs / jobsBrownsville || 0,
						brownsvilleSales: plant.brownsvilleSales / jobsBrownsville || 0,
						brownsvilleGross: plant.brownsvilleGross / jobsBrownsville || 0,
						client: "All Clients",
						totalCogsTheorical: totalCogsTheorical,
						totalCogsActual: totalCogsActual,
						totalCogsDelta: totalCogsDelta || 0,
					};
				});

				setList(newList);
				setListCSV(listRows2);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setOptionsPlant(list);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				{franchise !== "All" && (
					<Table
						columns={columns}
						dataSource={list}
						expandable={{
							expandedRowRender,
						}}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [50, 100],
							defaultPageSize: 50,
							showSizeChanger: true,
						}}
						scroll={{
							x: "max-content",
						}}
						style={{
							minWidth: "100%",
						}}
						onRow={(record) => ({
							style: {
								background: "#7686bbff",
							},
						})}
						summary={summaryParent}
					/>
				)}
				{franchise === "All" && (
					<Table
						title={() => "Franchise 57Concrete"}
						columns={columns}
						dataSource={list.filter((i) => i.franchise === "57Concrete")}
						expandable={{
							expandedRowRender,
						}}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [50, 100],
							defaultPageSize: 50,
							showSizeChanger: true,
						}}
						scroll={{
							x: "max-content",
						}}
						style={{
							minWidth: "100%",
						}}
						onRow={(record) => ({
							style: {
								background: "#7686bbff",
							},
						})}
						summary={summaryParent}
					/>
				)}
				{franchise === "All" && (
					<Table
						title={() => "Franchise Castle"}
						columns={columns}
						dataSource={list.filter((i) => i.franchise === "Castle")}
						expandable={{
							expandedRowRender,
						}}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [50, 100],
							defaultPageSize: 50,
							showSizeChanger: true,
						}}
						scroll={{
							x: "max-content",
						}}
						style={{
							minWidth: "100%",
						}}
						onRow={(record) => ({
							style: {
								background: "#7686bbff",
							},
						})}
						summary={summaryParent}
					/>
				)}
				{franchise === "All" && (
					<Table
						title={() => "Franchise Valley Wide"}
						columns={columns}
						dataSource={list.filter((i) => i.franchise === "Valley Wide")}
						expandable={{
							expandedRowRender,
						}}
						pagination={{
							position: ["bottomRight"],
							pageSizeOptions: [50, 100],
							defaultPageSize: 50,
							showSizeChanger: true,
						}}
						scroll={{
							x: "max-content",
						}}
						style={{
							minWidth: "100%",
						}}
						onRow={(record) => ({
							style: {
								background: "#7686bbff",
							},
						})}
						summary={summaryParent}
					/>
				)}
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangePlantPicker = (value) => {
		setPlant(value.value);
		setPlantName(value.label);
	};
	const onChangeFranchisePicker = (value) => {
		setFranchise(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderDates = () => {
		return (
			<Flex gap={"middle"}>
				<Row>
					<Col span={24}>
						<Text>Dates</Text>
					</Col>
					<Col span={24}>
						<RangePicker
							defaultValue={[
								dayjs(startDate, "MM/DD/YYYY"),
								dayjs(endDate, "MM/DD/YYYY"),
							]}
							onChange={onRangeChange}
							format={"MM/DD/YYYY"}
							size="large"
							disabled={loading}
							allowClear={false}
						/>
					</Col>
				</Row>

				<Row>
					<Col span={24}>
						<Text>Plant</Text>
					</Col>
					<Col span={24}>
						<Select
							showSearch
							placeholder={`Select plant`}
							optionFilterProp="children"
							size="large"
							onChange={onChangePlantPicker}
							filterOption={filterOption}
							options={optionsPlant}
							disabled={loading}
							value={plant}
							style={{
								width: "250px",
							}}
							allowClear={false}
							labelInValue={true}
						/>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Text>Franchise</Text>
					</Col>
					<Col span={24}>
						<Select
							showSearch
							placeholder={`Select franchise`}
							optionFilterProp="children"
							size="large"
							onChange={onChangeFranchisePicker}
							filterOption={filterOption}
							options={[
								{ value: "All", label: "All" },
								...franchises57ClientsOptions,
							]}
							disabled={loading}
							value={franchise}
							style={{
								width: "250px",
							}}
							allowClear={false}
						/>
					</Col>
				</Row>
			</Flex>
			// <CustomSearch
			// 	loading={loading}
			// 	startDate={startDate}
			// 	endDate={endDate}
			// 	dateFormat={"MM/DD/YYYY"}
			// 	onRangeChange={onRangeChange}
			// 	onChangePicker={onChangePlantPicker}
			// 	pickerValue={plant}
			// 	pickerWidth={"250px"}
			// 	labelPicker={"Plant"}
			// 	disabledPicker={loading}
			// 	optionsPicker={optionsPlant}
			// />
		);
	};

	function getFlattenedHeaders(columns, parent = "") {
		return columns.flatMap((col) => {
			const title = col.title;
			if (col.children) {
				return getFlattenedHeaders(col.children, title);
			}
			return title;
		});
	}

	function getFlattenedKeys(columns, parent = "") {
		return columns.flatMap((col) => {
			if (col.children) {
				return getFlattenedKeys(col.children, parent); // skip grouping name
			}
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const isNumber = (v) => typeof v === "number" && Number.isFinite(v);

	const buildBody = (list, franchise) => {
		let data = [];

		if (list.length === 0) {
			return data;
		}

		const headers = getFlattenedHeaders(columns2);
		const keys = getFlattenedKeys(columns2);

		//MAIN DATA
		data.push(["PLANT REPORT DETAIL"]);
		data.push(["PLANT REPORT SUMMARY"]);
		data.push([]);
		data.push(["Lower", "Upper"]);
		const start = `${
			startDate.month() + 1
		}/${startDate.date()}/${startDate.year()}`;
		const end = `${endDate.month() + 1}/${endDate.date()}/${endDate.year()}`;
		data.push([start, end]);
		data.push([]);
		data.push([
			"Plant",
			plant === "All" ? "All Plants" : list[0].plant,
			"",
			"Franchise",
			franchise,
		]);
		data.push([]);

		//MAIN HEADER
		list.map((itemList) => {
			const cogsNames = itemList.jobs[0].aggregate
				? itemList.jobs[0].aggregate.cogs.map((cog) => cog.cog.material)
				: [];
			let theoricalCogsSingle = itemList.jobs[0].aggregate
				? itemList.jobs[0].aggregate.cogs.map(
						(cog) => `theorical-${cog.cog._id}`
				  )
				: [];
			let actualCogsSingle = itemList.jobs[0].aggregate
				? itemList.jobs[0].aggregate.cogs.map((cog) => `actual-${cog.cog._id}`)
				: [];
			let deltaCogsSingle = itemList.jobs[0].aggregate
				? itemList.jobs[0].aggregate.cogs.map((cog) => `delta-${cog.cog._id}`)
				: [];
			theoricalCogsSingle = [...theoricalCogsSingle, "totalCogsTheorical"];
			actualCogsSingle = [...actualCogsSingle, "totalCogsActual"];
			deltaCogsSingle = [...deltaCogsSingle, "totalCogsDelta"];

			const topHeader = [
				" ",
				" ",
				plantName !== "All" && " ",
				" ",
				" ",
				" ",
				" ",
				(plantName === "All" || plantName === "Mission") && "CY",
				(plantName === "All" || plantName === "San Benito") && "CY",
				(plantName === "All" || plantName === "Brownsville") && "CY",
				// "",
				// "Commission by plant",
				// "",
				// "",
				// "Seller Payout",
				// "",
				" ",
				(plantName === "All" || plantName === "Mission") && "COGS",
				(plantName === "All" || plantName === "San Benito") && "COGS",
				(plantName === "All" || plantName === "Brownsville") && "COGS",
				(plantName === "All" || plantName === "Mission") && "SALES",
				(plantName === "All" || plantName === "San Benito") && "SALES",
				(plantName === "All" || plantName === "Brownsville") && "SALES",
				(plantName === "All" || plantName === "Mission") && "GROSS",
				(plantName === "All" || plantName === "San Benito") && "GROSS",
				(plantName === "All" || plantName === "Brownsville") && "GROSS",
				(plantName === "All" || plantName === "Mission") && "COGS TOTAL",
				(plantName === "All" || plantName === "San Benito") && "COGS TOTAL",
				(plantName === "All" || plantName === "Brownsville") && "COGS TOTAL",
				(plantName === "All" || plantName === "Mission") && "SALES TOTAL",
				(plantName === "All" || plantName === "San Benito") && "SALES TOTAL",
				(plantName === "All" || plantName === "Brownsville") && "SALES TOTAL",
				(plantName === "All" || plantName === "Mission") && "GROSS TOTAL",
				(plantName === "All" || plantName === "San Benito") && "GROSS TOTAL",
				(plantName === "All" || plantName === "Brownsville") && "GROSS TOTAL",
				...(plantName !== "All" ? cogsNames.map(() => "THEORICAL") : []),
				plantName !== "All" && "THEORICAL TOTAL",
				...(plantName !== "All" ? cogsNames.map(() => "ACTUAL") : []),
				plantName !== "All" && "ACTUAL TOTAL",
				...(plantName !== "All" ? cogsNames.map(() => "DELTA") : []),
				plantName !== "All" && "DELTA TOTAL",

				// "COGS",
				// "SALES",
				// "GROSS",
			].filter(Boolean);
			data.push(topHeader);

			//SUB HEADER
			if (plant === "All") {
				data.push(headers);
			} else {
				data.push([
					...headers,
					...cogsNames,
					"",
					...cogsNames,
					"",
					...cogsNames,
				]);
			}

			//EACH LINE
			const childrenList = listCSV.filter((l) => l.key === itemList.key);
			childrenList.map((children) => {
				let newRow = [];
				keys.forEach((key) => {
					newRow.push(
						isNumber(children[key])
							? children[key].toFixed(2)
							: children[key] ?? ""
					);
				});
				if (plant !== "All") {
					theoricalCogsSingle.forEach((key) => {
						newRow.push(
							isNumber(children[key])
								? children[key].toFixed(2)
								: children[key] ?? ""
						);
					});
					actualCogsSingle.forEach((key) => {
						newRow.push(
							isNumber(children[key])
								? children[key].toFixed(2)
								: children[key] ?? ""
						);
					});
					deltaCogsSingle.forEach((key) => {
						newRow.push(
							isNumber(children[key])
								? children[key].toFixed(2)
								: children[key] ?? ""
						);
					});
				}
				data.push(newRow);
			});
			//SUBTOTAL
			let totalRow = plant !== "All" ? ["", "", "Subtotal"] : ["", "Subtotal"];
			keys.slice(plant !== "All" ? 3 : 2).forEach((key) => {
				if (
					key === "client" ||
					key === "missionCogs" ||
					key === "sanbenitoCogs" ||
					key === "brownsvilleCogs" ||
					key === "missionSales" ||
					key === "sanbenitoSales" ||
					key === "brownsvilleSales" ||
					key === "missionGross" ||
					key === "sanbenitoGross" ||
					key === "brownsvilleGross"
				) {
					totalRow.push("");
				} else {
					totalRow.push(
						isNumber(itemList[key])
							? itemList[key].toFixed(2)
							: itemList[key] ?? ""
					);
				}
			});
			if (plant !== "All") {
				const theoricalCogsTotalKeys = itemList.jobs[0].aggregate
					? itemList.jobs[0].aggregate.cogs.map(
							(cog) => `theorical-${cog.cog._id}-total`
					  )
					: [];
				theoricalCogsTotalKeys.forEach((key) => {
					totalRow.push(
						isNumber(itemList[key])
							? itemList[key].toFixed(2)
							: itemList[key] ?? ""
					);
				});
				totalRow.push(
					isNumber(itemList["totalCogsTheorical"])
						? itemList["totalCogsTheorical"].toFixed(2)
						: itemList["totalCogsTheorical"] ?? ""
				);
			}
			data.push(totalRow);

			//DATA BELOW SUBTOTAL
			let totalRow2 = plant !== "All" ? ["", "", ""] : ["", ""];
			keys.slice(plant !== "All" ? 3 : 2).forEach((key) => {
				if (key === "missionSalesTotal" || key === "missionGrossTotal") {
					totalRow2.push(
						(itemList[key] / itemList["missionCY"] || 0).toFixed(2)
					);
				} else if (
					key === "sanbenitoSalesTotal" ||
					key === "sanbenitoGrossTotal"
				) {
					totalRow2.push(
						(itemList[key] / itemList["sanbenitoCY"] || 0).toFixed(2)
					);
				} else if (
					key === "brownsvilleSalesTotal" ||
					key === "brownsvilleGrossTotal"
				) {
					totalRow2.push(
						(itemList[key] / itemList["brownsvilleCY"] || 0).toFixed(2)
					);
				} else {
					totalRow2.push("");
				}
			});
			data.push(totalRow2);
			data.push([]);
		});

		//TOTAL
		let totalRow3 = plant !== "All" ? ["", "", "", "Total"] : ["", "", "Total"];
		keys.slice(plant !== "All" ? 4 : 3).forEach((key) => {
			if (
				key === "jobId" ||
				key === "client" ||
				key === "totalAverage" ||
				key === "missionCogs" ||
				key === "sanbenitoCogs" ||
				key === "brownsvilleCogs" ||
				key === "missionSales" ||
				key === "sanbenitoSales" ||
				key === "brownsvilleSales" ||
				key === "missionGross" ||
				key === "sanbenitoGross" ||
				key === "brownsvilleGross"
			) {
				totalRow3.push("");
			} else {
				totalRow3.push(
					list
						.reduce((acc, item) => {
							return acc + item[key];
						}, 0)
						.toFixed(2)
				);
			}
		});

		data.push(totalRow3);
		data.push([]);
		return data;
	};

	const handleExportXlsx = () => {
		let finalData = [];
		if (franchise === "All") {
			const data = buildBody(
				list.filter((i) => i.franchise === "57Concrete"),
				"57Concrete"
			);
			const data2 = buildBody(
				list.filter((i) => i.franchise === "Castle"),
				"Castle"
			);
			const data3 = buildBody(
				list.filter((i) => i.franchise === "Valley Wide"),
				"Valley Wide"
			);
			finalData = [...data, ...data2, ...data3];
		} else {
			const data = buildBody(list, franchise);
			finalData = data;
		}

		const ws = XLSX.utils.aoa_to_sheet(finalData);

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(
			wb,
			ws,
			plant === "All" ? "All Plants" : list[0].plant
		);

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Sales Report By Plant.xlsx`);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={handleExportXlsx}
							loading={loading}
							disabled={list.length === 0}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	const onSuccessAddedBatched = () => {
		setModalCogsOpen(false);
		setRefresh((prev) => !prev);
	};

	const ModalAddCogsBatched = () => {
		return (
			<Modal
				title="Add Batched Data"
				open={modalCogsOpen}
				onCancel={() => setModalCogsOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				centered
				width={500}
				destroyOnClose={false}
			>
				<BatchedDataModal
					cogs={cogsRef.current}
					jobs={jobIdsRef.current}
					onSuccess={onSuccessAddedBatched}
				/>
			</Modal>
		);
	};

	return (
		<Layout
			title="Rate Per Plant Report"
			description="Plant Report"
			type="large"
		>
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
				<ModalAddCogsBatched />
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default SalesByPlantSummary;
